// How long a store has been undeployed — the "AON" column on the dashboard's
// Undeployed Stores tab. Always in days: "13d", "62d", "1,095d". Months and
// years hid the difference between, say, 61 and 89 days behind the same "2m".

const DAY_MS = 86_400_000;

/**
 * Whole days from a YYYY-MM-DD start to today — or to `asOf` (YYYY-MM-DD) when
 * the dashboard is showing a past month's last day. null when the start is
 * unknown, unreadable or in the future.
 */
export const undeployedDays = (since?: string | null, asOf?: string | null, today: Date = new Date()): number | null => {
  if (!since) return null;
  const start = new Date(`${String(since).slice(0, 10)}T00:00:00`);
  if (Number.isNaN(start.getTime())) return null;
  const end = asOf ? new Date(`${asOf}T00:00:00`) : today;
  const days = Math.floor((end.getTime() - start.getTime()) / DAY_MS);
  return days < 0 ? null : days;
};

/** The cell text: "—" when unknown, "Today" for a store that emptied today, else "<n>d". */
export const formatUndeployedAon = (since?: string | null, asOf?: string | null, today: Date = new Date()): string => {
  const days = undeployedDays(since, asOf, today);
  if (days === null) return '—';
  // "Today" would be wrong against a past month's last day.
  if (days === 0) return asOf ? '0d' : 'Today';
  return `${days.toLocaleString('en-IN')}d`;
};
